<template>
  <div>
    <logged-in-header />
    <locker-deliveries />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import lockerDeliveries from "../components/locker-deliveries/LockerDeliveries";

export default {
  components: {
    loggedInHeader,
    lockerDeliveries
  }
};
</script>
